'use strict';

var cov_2nk5x3yeg7 = function () {
  var path = '/Users/jvvbsocianova/Projects/socianova/marty/src/app/marty.service.js',
      hash = '50b1236254a6c9cf62d8b1d0c8c6f8e53c589c11',
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: '/Users/jvvbsocianova/Projects/socianova/marty/src/app/marty.service.js',
    statementMap: {
      '0': {
        start: {
          line: 1,
          column: 0
        },
        end: {
          line: 90,
          column: 5
        }
      },
      '1': {
        start: {
          line: 4,
          column: 4
        },
        end: {
          line: 89,
          column: 6
        }
      },
      '2': {
        start: {
          line: 11,
          column: 22
        },
        end: {
          line: 11,
          column: 32
        }
      },
      '3': {
        start: {
          line: 12,
          column: 24
        },
        end: {
          line: 15,
          column: 10
        }
      },
      '4': {
        start: {
          line: 17,
          column: 8
        },
        end: {
          line: 20,
          column: 13
        }
      },
      '5': {
        start: {
          line: 19,
          column: 12
        },
        end: {
          line: 19,
          column: 48
        }
      },
      '6': {
        start: {
          line: 22,
          column: 8
        },
        end: {
          line: 22,
          column: 29
        }
      },
      '7': {
        start: {
          line: 30,
          column: 22
        },
        end: {
          line: 30,
          column: 32
        }
      },
      '8': {
        start: {
          line: 31,
          column: 24
        },
        end: {
          line: 34,
          column: 10
        }
      },
      '9': {
        start: {
          line: 36,
          column: 8
        },
        end: {
          line: 39,
          column: 13
        }
      },
      '10': {
        start: {
          line: 38,
          column: 12
        },
        end: {
          line: 38,
          column: 48
        }
      },
      '11': {
        start: {
          line: 41,
          column: 8
        },
        end: {
          line: 41,
          column: 29
        }
      },
      '12': {
        start: {
          line: 49,
          column: 22
        },
        end: {
          line: 49,
          column: 32
        }
      },
      '13': {
        start: {
          line: 51,
          column: 24
        },
        end: {
          line: 55,
          column: 10
        }
      },
      '14': {
        start: {
          line: 57,
          column: 8
        },
        end: {
          line: 66,
          column: 13
        }
      },
      '15': {
        start: {
          line: 59,
          column: 27
        },
        end: {
          line: 59,
          column: 47
        }
      },
      '16': {
        start: {
          line: 61,
          column: 12
        },
        end: {
          line: 63,
          column: 15
        }
      },
      '17': {
        start: {
          line: 62,
          column: 14
        },
        end: {
          line: 62,
          column: 59
        }
      },
      '18': {
        start: {
          line: 65,
          column: 12
        },
        end: {
          line: 65,
          column: 34
        }
      },
      '19': {
        start: {
          line: 68,
          column: 8
        },
        end: {
          line: 68,
          column: 29
        }
      },
      '20': {
        start: {
          line: 72,
          column: 24
        },
        end: {
          line: 80,
          column: 10
        }
      },
      '21': {
        start: {
          line: 82,
          column: 8
        },
        end: {
          line: 87,
          column: 13
        }
      },
      '22': {
        start: {
          line: 84,
          column: 29
        },
        end: {
          line: 84,
          column: 49
        }
      },
      '23': {
        start: {
          line: 86,
          column: 12
        },
        end: {
          line: 86,
          column: 89
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 3,
            column: 27
          },
          end: {
            line: 3,
            column: 28
          }
        },
        loc: {
          start: {
            line: 3,
            column: 72
          },
          end: {
            line: 90,
            column: 3
          }
        }
      },
      '1': {
        name: '(anonymous_1)',
        decl: {
          start: {
            line: 18,
            column: 16
          },
          end: {
            line: 18,
            column: 17
          }
        },
        loc: {
          start: {
            line: 18,
            column: 35
          },
          end: {
            line: 20,
            column: 11
          }
        }
      },
      '2': {
        name: '(anonymous_2)',
        decl: {
          start: {
            line: 37,
            column: 16
          },
          end: {
            line: 37,
            column: 17
          }
        },
        loc: {
          start: {
            line: 37,
            column: 35
          },
          end: {
            line: 39,
            column: 11
          }
        }
      },
      '3': {
        name: '(anonymous_3)',
        decl: {
          start: {
            line: 58,
            column: 16
          },
          end: {
            line: 58,
            column: 17
          }
        },
        loc: {
          start: {
            line: 58,
            column: 35
          },
          end: {
            line: 66,
            column: 11
          }
        }
      },
      '4': {
        name: '(anonymous_4)',
        decl: {
          start: {
            line: 61,
            column: 31
          },
          end: {
            line: 61,
            column: 32
          }
        },
        loc: {
          start: {
            line: 61,
            column: 36
          },
          end: {
            line: 63,
            column: 13
          }
        }
      },
      '5': {
        name: '(anonymous_5)',
        decl: {
          start: {
            line: 83,
            column: 16
          },
          end: {
            line: 83,
            column: 17
          }
        },
        loc: {
          start: {
            line: 83,
            column: 35
          },
          end: {
            line: 87,
            column: 11
          }
        }
      }
    },
    branchMap: {
      '0': {
        loc: {
          start: {
            line: 48,
            column: 16
          },
          end: {
            line: 48,
            column: 29
          }
        },
        type: 'default-arg',
        locations: [{
          start: {
            line: 48,
            column: 25
          },
          end: {
            line: 48,
            column: 29
          }
        }]
      }
    },
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0
    },
    f: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0
    },
    b: {
      '0': [0]
    },
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

++cov_2nk5x3yeg7.s[0];
angular.module('app').factory('MartyService', function ($http, $window, $q, lodash, moment, API) {
  ++cov_2nk5x3yeg7.f[0];
  ++cov_2nk5x3yeg7.s[1];

  return {

    /**
     * Récupérer indicateurs.
     */

    getIndicators: function getIndicators() {
      var defer = (++cov_2nk5x3yeg7.s[2], $q.defer());
      var request = (++cov_2nk5x3yeg7.s[3], $http({
        url: API + '/datawh/indicators',
        method: 'GET'
      }));

      ++cov_2nk5x3yeg7.s[4];
      request.then(function (responseSuccess) {
        ++cov_2nk5x3yeg7.f[1];
        ++cov_2nk5x3yeg7.s[5];

        defer.resolve(responseSuccess.data);
      });

      ++cov_2nk5x3yeg7.s[6];
      return defer.promise;
    },


    /**
     * Récupérer les marts.
     */

    getMarts: function getMarts() {
      var defer = (++cov_2nk5x3yeg7.s[7], $q.defer());
      var request = (++cov_2nk5x3yeg7.s[8], $http({
        url: API + '/datawh/marts',
        method: 'GET'
      }));

      ++cov_2nk5x3yeg7.s[9];
      request.then(function (responseSuccess) {
        ++cov_2nk5x3yeg7.f[2];
        ++cov_2nk5x3yeg7.s[10];

        defer.resolve(responseSuccess.data);
      });

      ++cov_2nk5x3yeg7.s[11];
      return defer.promise;
    },


    /**
     * Récupérer les valeurs
     */

    getValues: function getValues() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (++cov_2nk5x3yeg7.b[0][0], null);

      var defer = (++cov_2nk5x3yeg7.s[12], $q.defer());

      var request = (++cov_2nk5x3yeg7.s[13], $http({
        url: API + '/datawh/values',
        method: 'POST',
        data: params
      }));

      ++cov_2nk5x3yeg7.s[14];
      request.then(function (responseSuccess) {
        ++cov_2nk5x3yeg7.f[3];

        var values = (++cov_2nk5x3yeg7.s[15], responseSuccess.data);

        ++cov_2nk5x3yeg7.s[16];
        lodash.map(values, function (o) {
          ++cov_2nk5x3yeg7.f[4];
          ++cov_2nk5x3yeg7.s[17];

          o.date_valeur_moment = moment(o.date_valeur);
        });

        ++cov_2nk5x3yeg7.s[18];
        defer.resolve(values);
      });

      ++cov_2nk5x3yeg7.s[19];
      return defer.promise;
    },
    exportValues: function exportValues(values, indicator, periodInterval) {
      var request = (++cov_2nk5x3yeg7.s[20], $http({
        url: API + '/datawh/export',
        method: 'POST',
        data: {
          values: values,
          indicator: indicator,
          periodInterval: periodInterval
        }
      }));

      ++cov_2nk5x3yeg7.s[21];
      request.then(function (responseSuccess) {
        ++cov_2nk5x3yeg7.f[5];

        var filename = (++cov_2nk5x3yeg7.s[22], responseSuccess.data);
        // download file
        ++cov_2nk5x3yeg7.s[23];
        $window.open(API + '/datawh/download-export?filename=' + filename, '_blank');
      });
    }
  };
});